import { Card, Form, Input, Button, Switch, Divider, message } from 'antd';
import { SettingOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

export function SettingsPage() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const handleSave = (values: any) => {
    console.log('Settings saved:', values);
    message.success('Settings saved successfully!');
  };

  return (
    <div className="min-h-screen p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8 flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">Settings</h2>
            <p className="text-sm text-gray-600">
              Manage your account settings and preferences
            </p>
          </div>
          <Button 
            icon={<ArrowLeftOutlined />} 
            onClick={() => navigate('/app')}
          >
            Back to Apps
          </Button>
        </div>

        {/* Settings Card */}
        <Card>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSave}
            initialValues={{
              emailNotifications: true,
              darkMode: false,
            }}
          >
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <SettingOutlined /> General Settings
            </h3>
            
            <Form.Item
              label="Email Notifications"
              name="emailNotifications"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Form.Item
              label="Dark Mode"
              name="darkMode"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Divider />

            <h3 className="text-lg font-semibold mb-4">Change Password</h3>

            <Form.Item
              label="Current Password"
              name="currentPassword"
            >
              <Input.Password placeholder="Enter current password" />
            </Form.Item>

            <Form.Item
              label="New Password"
              name="newPassword"
            >
              <Input.Password placeholder="Enter new password" />
            </Form.Item>

            <Form.Item
              label="Confirm New Password"
              name="confirmPassword"
            >
              <Input.Password placeholder="Confirm new password" />
            </Form.Item>

            <Divider />

            <Form.Item>
              <Button type="primary" htmlType="submit">
                Save Settings
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
}

export default SettingsPage;